import { useParams, Link, Navigate } from 'react-router-dom';
import Seo from './Seo';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { ESSAYS } from '../content/essays';

export default function EssayView() {
    const { slug } = useParams();
    const essay =
        ESSAYS.find((e) => e.slug === slug) ||
        ESSAYS.find((e) => String(e.id) === String(slug));

    if (!essay) {
        return (
            <main className="cx-page"><div className="cx-col">
                <Seo title="Essay not found" noindex />
                <Link to="/academic-writings" className="cx-back">← Academic Writings</Link>
                <p style={{ color: '#3a342c' }}>That essay couldn't be found — it may have been moved or removed.</p>
            </div></main>
        );
    }

    // Old UUID link → send it to the canonical slug URL
    if (essay.slug && slug !== essay.slug) {
        return <Navigate to={`/academic-writings/${essay.slug}`} replace />;
    }

    return (
        <main className="cx-page"><div className="cx-col">
            <Seo
                title={essay.title}
                description={essay.blurb}
                path={`/academic-writings/${essay.slug}`}
                type="article"
                jsonLd={{
                    '@context': 'https://schema.org', '@type': 'Article',
                    headline: essay.title, description: essay.blurb,
                    author: { '@type': 'Person', name: 'Ethan Park' },
                    keywords: (essay.tags || []).join(', '),
                }}
            />

            <Link to="/academic-writings" className="cx-back">← Academic Writings</Link>

            <header className="essay-head">
                <p className="essay-eyebrow">{[essay.course, essay.year].filter(Boolean).join(' · ')}</p>
                <h1>{essay.title}</h1>
                {essay.subtitle && <p className="essay-sub">{essay.subtitle}</p>}
            </header>

            <div className="md-content essay-body">
                <ReactMarkdown remarkPlugins={[remarkGfm]}>{essay.content || ''}</ReactMarkdown>
            </div>

            <svg className="cx-sprig" style={{ width: 110, marginTop: '2.6rem' }} viewBox="0 0 130 24" fill="none" stroke="#b79bc2" strokeWidth="1.2" strokeLinecap="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M10 12 H120" />
                <path d="M46 12 c6 -7 14 -8 18 -12 c-8 1 -14 5 -18 12z" fill="#ece2f2" stroke="none" />
                <path d="M46 12 c6 7 14 8 18 12 c-8 -1 -14 -5 -18 -12z" fill="#ece2f2" stroke="none" />
                <path d="M84 12 c-6 -7 -14 -8 -18 -12 c8 1 14 5 18 12z" fill="#ece2f2" stroke="none" />
                <path d="M84 12 c-6 7 -14 8 -18 12 c8 -1 14 -5 18 -12z" fill="#ece2f2" stroke="none" />
                <circle cx="65" cy="12" r="2.2" fill="#b79bc2" stroke="none" />
            </svg>

            <Link to="/academic-writings" className="cx-back" style={{ marginTop: '2.4rem', marginBottom: 0 }}>← back to Academic Writings</Link>
        </div></main>
    );
}